// DS9.4.3, DS9.4.3M
import React from 'react';
import { getIsShortStatus } from '../../_helpers';
import FeedCardLayout from '../_partials/FeedCardLayout';
import StatusTierPaywall from './StatusTierPaywall';
import ShortStatus from './ShortStatus';
import LongStatus from './LongStatus';
const StatusFeedCardContents = (props)=>{
    const { className, deviation, extraActions, withWatchOrSubscribeButton, withCommentSuggestions } = props;
    const isShortStatus = getIsShortStatus(deviation);
    return /*#__PURE__*/ React.createElement(FeedCardLayout, {
        className: className,
        deviation: deviation,
        extraActions: extraActions,
        isExpandable: !isShortStatus,
        withWatchOrSubscribeButton: withWatchOrSubscribeButton,
        withCommentSuggestions: withCommentSuggestions,
        withCommentControl: true,
        withFaveControl: true
    }, /*#__PURE__*/ React.createElement(StatusTierPaywall, {
        deviation: deviation
    }, isShortStatus ? /*#__PURE__*/ React.createElement(ShortStatus, props) : /*#__PURE__*/ React.createElement(LongStatus, props)));
};
StatusFeedCardContents.displayName = 'StatusFeedCardContents';
export default StatusFeedCardContents;

//# sourceMappingURL=Status.js.map